/* @flow */
import * as React from 'react';
import { inject } from 'mobx-react';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';

import CentralForm from 'components/CentralForm/CentralForm.js';

//LoginFailed.js
@translate()
@inject('authenticationStore')
export class LoginFailed extends React.Component<*> {
  render(): React.Element<*> {
    const t: Function = this.props.t;
    return (
      <CentralForm>
        <div>
          {this.props.authenticationStore.loginError === 'max_failed_attempts' ? (
            <React.Fragment>
              <h1>{this.props.t('general:accounts.locked')}</h1>
              {t('general:accounts.messages.too_many_attempts')}
              <br />
              <Link to="/forgotten-password">{t('general:accounts.messages.reset_password')}</Link>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <h1>{this.props.t('general:accounts.login_failed')}</h1>
              {t('general:accounts.messages.invalid_combination')}
              <br />
              <Link to="/login">{t('general:accounts.please_try_again')}</Link>
            </React.Fragment>
          )}
        </div>
      </CentralForm>
    );
  }
}

export default LoginFailed;
